<div class="gm-game gm-sudoku">
  <div class="gm-game-bar">
    <span class="gm-game-title">Sudoku</span>
    <div class="gm-game-actions">
      <button class="gm-btn" (click)="newGame()">New</button>
    </div>
  </div>
  <div class="gm-game-body">
    <div class="gm-levels">
      @for (lv of levels; track lv.id) {
        <button class="gm-lvl" [class.on]="level() === lv.id" (click)="newGame(lv.id)">
          <span class="gm-lvl-name">{{ lv.label }}</span>
        </button>
      }
    </div>
    <div class="sd-board">
      @for (v of cells(); track $index) {
        <div
          class="sd-cell"
          [class.given]="isGiven($index)"
          [class.sel]="$index === sel()"
          [class.same]="$index !== sel() && same($index)"
          [class.peer]="$index !== sel() && !same($index) && peer($index)"
          [class.bad]="conflict($index)"
          [class.bb]="bb($index)"
          [style.borderRight]="borderRight($index)"
          (click)="select($index)">{{ v || '' }}</div>
      }
    </div>
    @if (solved()) {
      <div class="gm-win">Solved! 🎉 <button class="gm-btn primary" (click)="newGame()">New</button></div>
    } @else {
      <div class="sd-pad">
        @for (n of [1, 2, 3, 4, 5, 6, 7, 8, 9]; track n) {
          <button class="sd-key" (click)="set(n)">{{ n }}</button>
        }
        <button class="sd-key erase" (click)="set(0)">Erase</button>
      </div>
    }
  </div>
</div>
